module.exports = __webpack_public_path__ + "assets/filter-discounts-e7c666.svg";